module.exports = __webpack_public_path__ + "static/media/鹽酥雞便當.b3604fd5.jpg";